namespace GeniuzPOS.Member {
    export class PsMeberStatusColumns {
        static columnsKey = 'Member.PsMeberStatus';
    }
}
